<form *ngIf="formFields.length" class="cst-form-group" [formGroup]="customForm" (ngSubmit)="submitForm()">
    <ng-container class="row p-0" *ngFor="let data of formFields">
        <mat-form-field appearance="outline" *ngIf="(data.type != 'checkbox') && (data.type != 'select')" [ngClass]="{
          'readOnlyInput': data.readonly, 
          'mat-text-area': data.type === 'textarea', 
          'w-50': data.width === '50', 
          'redMarker': (formName === 'shippingAddress' && !haveValue(utils.getFormControlName(data.label)))
        }" [class]="data.class" appearance="outline">

            <mat-label>{{ data.label?.charAt(0).toUpperCase() + data.label?.slice(1).toLowerCase() }}</mat-label>

            <!-- Input for general types -->
            <input matInput class="cst-form-control" (focusout)="onFocus(data.label, false)"
                (focus)="onFocus(data.label, true)"
                *ngIf="(data.type !== 'textarea') && (data.for !== 'tel' && data.for !== 'pincode')" [type]="data.type"
                [formControlName]="utils.getFormControlName(data.label)" [name]="data.label" [placeholder]="data.label"
                [readonly]="data.readonly" autocomplete="on">

            <!-- Phone number or pincode input -->
            <input matInput class="cst-form-control" [ngClass]="{'telephone-input': data.for === 'tel'}"
                [formControlName]="utils.getFormControlName(data.label)" limitNumber [limitNumberObj]="{
            limitPhoneNum: true, 
            limitTo: data.maxLength, 
            formGroup: customForm, 
            formControlName: utils.getFormControlName(data.label)
          }" (focusout)="onFocus(data.label, false)" (focus)="onFocus(data.label, true)"
                *ngIf="data.for === 'tel' || data.for === 'pincode'" type="text"
                (input)="valueChangeHandler($event, data.label)" [placeholder]="data.label" [readonly]="data.readonly"
                [maxlength]="data.maxLength" [name]="data.label">

            <p class="numberPreValue" *ngIf="data.for === 'tel'"
                [hidden]="!(focusedControl === utils.getFormControlName(data.label) || haveValue(data.label))">
                +91
            </p>

            <!-- Textarea for long text -->
            <textarea matInput class="cst-form-control textArea" *ngIf="data.type === 'textarea'"
                [formControlName]="utils.getFormControlName(data.label)" [name]="data.label" [placeholder]="data.label">
        </textarea>

            <!-- Error messages -->
            <div class="errorIconContainer" *ngIf="checkValidation(data.label)">
                <img loading="lazy" class="errorImg" src="{{environment?.blobUrl}}/assets/icons/error.svg" alt="Error | Luminous">
            </div>
            <div class="errorDescription" *ngIf="checkValidation(data.label)">
                {{ checkValidationMessage(data) }}
            </div>
            <!-- <mat-error *ngIf="checkValidation(data.label)">
          {{ checkValidationMessage(data) }}
        </mat-error>
   -->
        </mat-form-field>

        <!-- IT IS FOR SELECT -->
        <mat-form-field appearance="outline" *ngIf="data.type == 'select'" [ngClass]="{'readOnlyInput':data.readonly}">
            <mat-label>{{data.label}}</mat-label>
            <mat-select [formControlName]="utils.getFormControlName(data.label)">
                <mat-option *ngFor="let selectData of data.selectList" [value]="selectData.value">
                    {{selectData.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- IT IS FOR CHECKBOX -->
        <div class="checkBoxContainer" *ngIf="data.type == 'checkbox'" [ngClass]="{'readOnlyInput':data.readonly}"
            [hidden]="data.hidden">
            <input [id]="data.label" [name]="data.label"
                (change)="valueUpdateOfCheckBox(data.label, $event, data.required)" type="checkbox"
                [formControlName]="utils.getFormControlName(data.label)" [checked]="data.value"
                [disabled]="data.disabled">
            <label [innerHTML]="data.text | safehtml" [for]="data.label"></label>
        </div>
    </ng-container>

    <button *ngIf="btnName" class="primaryBtn" type="submit" [disabled]="customForm.invalid">{{btnName}}</button>
</form>